export const buildTimelineQueries = ({ contactId, email, phone }) => {
  const queries = [];

  if (contactId) queries.push({ contact_id: contactId });
  if (email) queries.push({ email, unlinked: true });
  if (phone) queries.push({ phone, unlinked: true });

  return queries;
};

export const mergeTimelineEvents = (eventGroups, contactId) => {
  const merged = new Map();

  eventGroups.flat().forEach(event => {
    if (!event?.id || merged.has(event.id)) return;
    if (event.contact_id && String(event.contact_id) !== String(contactId)) {
      return;
    }

    merged.set(event.id, event);
  });

  return Array.from(merged.values()).sort(
    (a, b) =>
      new Date(b.received_at || b.updated_at) -
      new Date(a.received_at || a.updated_at)
  );
};
